import React, { useState, useEffect } from "react";
import "./VoucherDefaultSearchPage.scss"
import search from "../../assets/search-normal.svg"
import arrow from "../../assets/arrow-right.svg"
import close from "../../assets/close.svg"

import _ from "lodash";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import { useHistory } from 'react-router-dom';


import IMAGE_PLACEHOLDER from '../../assets/images/Images/vouchers-placeholder.jpg'
import { getAllData } from "../../../../../../../redux/resturantWidgetSlice";
const VoucherDefaultSearchPage = () => {
    const [searchKey, setSearchKey] = useState('')
    const [items, setItems] = useState([])
    const [data, setData] = useState(null)
    useEffect(() => {
        fetchDBData()
    }, []);
    const fetchDBData = async () => {
        await getAllData().then((result) => {
            setData(result?.data);
            if (result?.data && result?.data?.Categories && result?.data?.Categories?.length > 0) {
                let array = result?.data.Categories.map((val) => {
                    return val.MenuEntities.map((menuEntity) => {
                        const menuItem = _.find(result?.data.Items, { MenuItemID: menuEntity.ID });
                        return { ...menuItem, Category: val.Title.en };
                    });
                }).flat();

                setItems(array)
            }
        });
    }
    const history = useHistory()
    const searchedItems = (searchingValue) => {
        return searchingValue === "" ? items : items.filter(item => item.Title && item.Title.en && item.Title.en.toLowerCase().includes(searchingValue.toLowerCase()));
    }
    return (
        <div className="SearchPage">
            <div className='Voucher-search-wrapper-cont'>
                <div className="arrow-conat" onClick={() => {
                    history.goBack()
                }}>
                    <img alt="" src={arrow} className="arrowIc" />
                </div>
                <div className='Voucher-search-container'>
                    <img alt='' src={search} className='search-image' />
                    <input className='Voucher-search-input ' placeholder='search' value={searchKey} onChange={e => { setSearchKey(e.target.value) }} />
                    {searchKey !== "" && < img alt='' src={close} className='close-image' onClick={() => { setSearchKey("") }} />}
                </div>

            </div>

            <div className='Voucher-searched-container'>
                {searchedItems(searchKey).length > 0 ? searchedItems(searchKey).map((value, index) => {
                    return (
                        <div key={index} className='searched-item-cont' onClick={() => {
                            history.push('/item/' + value.MenuItemID + "/" + "new")
                            setSearchKey("")
                        }}>
                            <img alt='' className='searched-image-cont' src={value.ImageURL ? value.ImageURL : IMAGE_PLACEHOLDER} style={{ objectFit: !value.ImageURL ? "fill" : "" }} />
                            <div className='items-cont'>
                                <div className='searched-title'>
                                    {value.Title.en}</div>
                                <div className='searched-cat'>{value.Category}</div></div></div>
                    )
                }) : <div className='empty-search'>No results found for <b>{searchKey}</b></div>}</div>
        </div>
    )
}
export default VoucherDefaultSearchPage